import { keyframes, styled } from "goober";

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`;

export const PulsingIcon = styled("span")`
  display: flex;
  align-items: center;

  &[data-pending="true"] {
    animation: ${pulse} 1s ease-in-out infinite;
  }
`;
